import { StyleSheet, View } from 'react-native';
import { getAllergenColor } from '../constants/Allergens';

export default function AllergenBadges({ allergens, style, size = 12 }) {
  if (!allergens || !Array.isArray(allergens) || allergens.length === 0) {
    return null;
  }

  return (
    <View style={[styles.container, style]}>
      {allergens.map((allergen, index) => {
        if (!allergen) return null;
        const bgColor = getAllergenColor(allergen);

        return (
          <View
            key={`${allergen}-${index}`}
            style={[
              styles.circle,
              {
                backgroundColor: bgColor,
                width: size,
                height: size,
                borderRadius: size / 2,
              },
            ]}
          />
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
    backgroundColor: 'transparent',
    alignItems: 'center',
  },
  circle: {
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.5)',
  },
});
